'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = FormItemComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormItemComponent(props) {
	var className = props.className,
	    otherProps = (0, _objectWithoutProperties3.default)(props, ['className']);


	return _react2.default.createElement(_form2.default.Item, (0, _extends3.default)({}, otherProps, {
		className: (0, _classnames2.default)('mk-form-item', className)
	}));
}
module.exports = exports['default'];